import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

interface DisplayWallClockOptions {
  includeSubseconds?: boolean;
  timezone?: string;
}

/**
 * Displays a date/time in wall clock format
 * @param date - The date to display
 * @param options - Optional configuration including timezone
 * @returns Formatted time string (e.g., "3:45:12 PM")
 */
const displayWallClock = (date: Date, options?: DisplayWallClockOptions) => {
  try {
    const formatStr = options?.includeSubseconds ? 'h:mm:ss.SSS aaa' : 'h:mm:ss aaa';
    const dateObj = typeof date === 'string' ? parseISO(date) : date;

    // Use timezone if provided, otherwise use browser timezone
    if (options?.timezone) {
      return formatInTimeZone(dateObj, options.timezone, formatStr).toUpperCase();
    }

    return format(dateObj, formatStr).toUpperCase();
  } catch (e) {
    console.error(`date is ${date} and typeof date is ${typeof date}`);
    return 'INVALID DATE';
  }
};

export default displayWallClock;